import { Injectable } from '@angular/core';
import { ImageResizeOptions, ResizeResult } from '../models/image-utils';

@Injectable({
  providedIn: 'root'
})
export class ImageUtilsService {

  constructor() { }

  validateFileSize(file: File, maxSizeInMB: number): boolean {
    const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

    if (file.size > maxSizeInBytes) {
      throw new Error(`File too large! Maximum size: ${maxSizeInMB}MB. Your file: ${(file.size / 1024 / 1024).toFixed(2)}MB`);
    }

    return true;
  }

  async resizeImage(file: File, options: ImageResizeOptions): Promise<ResizeResult>{

    const bitmap = await createImageBitmap(file);

    const newDimensions = this.calculateNewDimensions(
      bitmap.width,
      bitmap.height,
      options.maxWidth,
      options.maxHeight
    );

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d')!;
    canvas.width = newDimensions.width;
    canvas.height = newDimensions.height;

    ctx.drawImage(bitmap, 0, 0, newDimensions.width, newDimensions.height);

    return new Promise((resolve, reject) => {
    canvas.toBlob(async (blob) => {
      if (!blob) {
        reject(new Error('Failed to resize image'));
        return;
      }

      const base64 = await this.blobToBase64(blob);

      resolve({
        base64,
        originalDimensions: { width: bitmap.width, height: bitmap.height },
        newDimensions,
        originalSize: file.size,
        newSize: blob.size
      });
    }, 'image/jpeg', options.quality);
  });
}

  private calculateNewDimensions(
      originalWidth: number,
      originalHeight: number,
      maxWidth: number,
      maxHeight: number) : { width: number; height: number } {

        let newWidth = originalWidth;
        let newHeight = originalHeight;

        if (originalWidth > maxWidth || originalHeight > maxHeight) {
      const aspectRatio = originalWidth / originalHeight;
      
      if (originalWidth > originalHeight) {
        newWidth = maxWidth;
        newHeight = maxWidth / aspectRatio;
        
        if (newHeight > maxHeight) {
          newHeight = maxHeight;
          newWidth = maxHeight * aspectRatio;
        }
      } else {
        newHeight = maxHeight;
        newWidth = maxHeight * aspectRatio;

        if (newWidth > maxWidth) {
          newWidth = maxWidth;
          newHeight = maxWidth / aspectRatio;
        }
      }
    }
    return { width: Math.round(newWidth), height: Math.round(newHeight) };
  }

  private blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  createImageInput(callback: (file: File) => void): void {
    
  }

}
